import React from "react";
import PdfBase from "./PdfBase";
import { generateSavvyPdf } from "./generator";
import ExcelBase from "../Excel/ExcelBase";

const PdfGenerator = ({
  company,
  schedule,
  scheduleData,
  notes,
  reviewNotes,
}) => {
  const sharedArgs = [company, schedule, scheduleData, notes, reviewNotes];

  return (
    <>
      <PdfBase
        company={company}
        generatePdf={(forView) => generateSavvyPdf(forView, ...sharedArgs)}
        downloadName='Savy Schedule'
        enableDraftView={true}
      />
      <ExcelBase
        generateExcel={(forView) =>
          generateSavvyPdf(forView, ...sharedArgs, true)
        }
      />
    </>
  );
};

export default PdfGenerator;
